// How a place gets its level, stated once so the About page and the tests read the same
// rules. src/lib/methodology.test.ts checks every rule here against the data, so a data
// update that breaks one fails the build instead of leaving the page saying something false.

import type { RiskLevel } from "./risk";

/**
 * The 13 states CDC's 2023 MMWR names for the highest rates of suspected alpha-gal cases:
 * "particularly parts of Oklahoma, Kansas, Arkansas, Missouri, Mississippi, Tennessee,
 * Kentucky, Illinois, Indiana, North Carolina, Virginia, Maryland, and Delaware"
 * (MMWR 2023;72(30):815–820, source id cdc-ags-distribution).
 */
export const MMWR_HIGHEST_RATE_STATES = [
  "OK",
  "KS",
  "AR",
  "MO",
  "MS",
  "TN",
  "KY",
  "IL",
  "IN",
  "NC",
  "VA",
  "MD",
  "DE",
] as const;

/** The most counties CDC lists as established in any "Spreading" state. */
export const SPREADING_MAX_ESTABLISHED = 5;

/** What each level rests on, in a sentence a reader can check against the state page. */
export const LEVEL_BASIS: Record<RiskLevel, string> = {
  low: "CDC lists no county in the state where Lone Star ticks are established. At most a few counties have a report.",
  emerging: `CDC lists the tick as established in a handful of counties at most (${SPREADING_MAX_ESTABLISHED} or fewer), often with reports from others nearby.`,
  established:
    "CDC lists Lone Star ticks as established in part or most of the state, inside the tick's documented range.",
  high: "Found here, and one of the 13 states CDC's 2023 report names for the highest rates of suspected alpha-gal cases.",
};
